import React from "react";
// import "./CartTable.scss";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";

export const CartTable = ({
  t,
  cart,
  getCurrencySymbol,
  onBatchChange,
  onPriceChange,
  onQuantityChange,
  onRemoveItem,
  disableScrollProps,
  itemTaxes,
  posTaxType,
  pharmacyStateCode,
  patientStateCode,
  posCompact,
  totals
}) => {
  const isSameState =
    !patientStateCode ||
    !pharmacyStateCode ||
    pharmacyStateCode === patientStateCode;

  // Calculate bill-level discount rate based on total taxable value
  const totalTaxableBeforeDiscount = cart.reduce((sum, item) => {
    const itemKey = `${item._id}-${item.selectedBatchId}`;
    const taxInfo = itemTaxes[itemKey];
    return sum + (taxInfo?.taxableAmount || 0);
  }, 0);

  const billDiscount = totals?.discount || 0;
  const billDiscountRate =
    totalTaxableBeforeDiscount > 0 ? billDiscount / totalTaxableBeforeDiscount : 0;

  return (
    <div className="table-responsive table-wrap">
      <Table className="align-middle rounded shadow-sm table-bordered table-sm" style={{ fontSize: 'smaller' }}>

        <thead>
          <tr>
            <th scope="col" className="text-nowrap">{t("Batch Number")}</th>
            <th scope="col">{t("Product")}</th>
            <th scope="col">{t("Manufacturer")}</th>
            <th scope="col" className="text-center">{t("Price (MRP)")}</th>
            <th scope="col" className="text-center">{t("Qty")}</th>
            <th scope="col" className="text-center">{t("Tax %")}</th>
            <th scope="col" className="text-center">{t("Taxable Value")}</th>
            {posTaxType === "gst" ? (
              isSameState ? (
                <>
                  <th scope="col" className="text-center">{t("CGST")}</th>
                  <th scope="col" className="text-center">{t("SGST")}</th>
                </>
              ) : (
                <th scope="col" className="text-center">{t("IGST")}</th>
              )
            ) : (
              <th scope="col" className="text-center">{t("VAT")}</th>
            )}
            <th scope="col" className="text-center">{t("Gross Total")}</th>
            <th scope="col" className="text-center"></th>
          </tr>
        </thead>
        <tbody>
          {cart.map((item, rowIndex) => {
            const itemKey = `${item._id}-${item.selectedBatchId}`;
            const taxInfo = itemTaxes[itemKey] || {};
            const taxRate = taxInfo.taxPercentage || 0;

            const taxableBeforeDiscount = taxInfo.taxableAmount || 0;
            const taxableAfterDiscount =
              taxableBeforeDiscount - taxableBeforeDiscount * billDiscountRate;

            let rowTax = 0;
            let rowCGST = 0;
            let rowSGST = 0;
            let rowIGST = 0;
            let rowVAT = 0;

            if (posTaxType === "gst") {
              if (isSameState) {
                rowTax = (taxableAfterDiscount * taxRate) / 100;
                rowCGST = rowTax / 2;
                rowSGST = rowTax / 2;
              } else {
                rowTax = (taxableAfterDiscount * taxRate) / 100;
                rowIGST = rowTax;
              }
            } else if (posTaxType === "vat") {
              rowVAT = (taxableAfterDiscount * taxRate) / 100;
              rowTax = rowVAT;
            }

            const itemGrossTotal = taxableAfterDiscount + rowTax;

            return (
              <tr key={itemKey}>
                <td>
                  {/* {item.isOTC === false || item.isOTC === null ? ( */}
                  {item.batchNumbers?.length > 0 ? (
                    <Form.Select
                      size="sm"
                      value={item.selectedBatchId}
                      onChange={(event) => onBatchChange(item._id, event.target.value)}
                    >
                      {item.batchList?.map((batch, index) => {
                        const isSelectedElsewhere = cart.some(
                          (ci, ciIndex) =>
                            ci._id === item._id &&
                            ci.selectedBatchId === batch._id &&
                            ciIndex !== rowIndex
                        );

                        return (
                          <option key={`${batch._id}-${index}`} value={batch._id} disabled={isSelectedElsewhere}>
                            {batch.batchNumber} {batch.taxPercentage ? `(${batch.taxPercentage}%)` : ''}
                            {isSelectedElsewhere ? " (Selected)" : ""}
                          </option>
                        );
                      })}
                    </Form.Select>
                  ) : (
                    <span>-</span>
                  )}
                </td>
                <td className="table-product-title" style={{ maxWidth: "80px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-saltName-${item._id}`}>{item.brandName}</Tooltip>}
                  >
                    <span>{item.saltName}</span>
                  </OverlayTrigger>
                </td>
                <td className="table-product-title" style={{ maxWidth: "80px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-${item._id}`}>{item.manufacturer}</Tooltip>}
                  >
                    <span>{item.manufacturer}</span>
                  </OverlayTrigger>
                </td>
                <td>
                  {/* <td className="text-center fw-bold">
                    {getCurrencySymbol()}{(item.salePrice || 0).toFixed(2)}
                  </td> */}
                  <div className="input-group custom-qty-input table-price-counter-nowrap">
                    <button
                      type="button"
                      className="button-minus icon-shape icon-sm btn-danger"
                      onClick={() =>
                        onPriceChange(item._id, item.selectedBatchId, "salePrice", Math.max(0, (item.salePrice || 0) - 0.01))
                      }
                    >
                      -
                    </button>
                    <input
                      type="number"
                      value={item.salePrice || 0}
                      step="0.01"
                      className="border-0 quantity-field incrementor"
                      onChange={(event) =>
                        onPriceChange(item._id, item.selectedBatchId, "salePrice", event.target.value)
                      }
                      {...disableScrollProps}
                    />
                    <button
                      type="button"
                      className="button-plus icon-shape icon-sm btn-primary"
                      onClick={() =>
                        onPriceChange(item._id, item.selectedBatchId, "salePrice", (item.salePrice || 0) + 0.01)
                      }
                    >
                      +
                    </button>
                  </div>
                </td>
                <td>
                  <div className="input-group custom-qty-input table-price-counter-nowrap">
                    <button
                      type="button"
                      className="button-minus icon-shape icon-sm btn-danger"
                      onClick={() =>
                        onQuantityChange(item._id, item.selectedBatchId, Math.max(1, (item.quantity || 1) - 1))
                      }
                    >
                      -
                    </button>
                    <input
                      type="number"
                      value={item.quantity || 1}
                      className="border-0 quantity-field incrementor"
                      min={1}
                      max={item.maxQuantity}
                      onChange={(event) =>
                        onQuantityChange(item._id, item.selectedBatchId, Number(event.target.value))
                      }
                      {...disableScrollProps}
                    />
                    <button
                      type="button"
                      className="button-plus icon-shape icon-sm btn-primary"
                      onClick={() =>
                        onQuantityChange(item._id, item.selectedBatchId, (item.quantity || 1) + 1)
                      }
                    >
                      +
                    </button>
                  </div>
                  <div style={{ fontSize: "0.8em", color: "#888", textAlign: "center" }}>
                    {t("Stock")}: <strong>{item.maxQuantity || 0}</strong>
                  </div>
                </td>
                <td className="text-center fw-bold">
                  {taxRate || 0}%
                </td>
                <td className="text-center fw-bold">
                  {getCurrencySymbol()}{taxableAfterDiscount.toFixed(2)}
                </td>
                {posTaxType === "gst" ? (
                  isSameState ? (
                    <>
                      <td className="text-center text-success">
                        {getCurrencySymbol()}{rowCGST.toFixed(2)}
                      </td>
                      <td className="text-center text-success">
                        {getCurrencySymbol()}{rowSGST.toFixed(2)}
                      </td>
                    </>
                  ) : (
                    <td className="text-center text-success">
                      {getCurrencySymbol()}{rowIGST.toFixed(2)}
                    </td>
                  )
                ) : (
                  <td className="text-center text-success">
                    {getCurrencySymbol()}{rowVAT.toFixed(2)}
                  </td>
                )}
                <td className="text-center fw-bold" style={{ fontSize: 'small' }}>
                  {getCurrencySymbol()}{itemGrossTotal.toFixed(2)}
                </td>
                <td className="text-center">
                  <button
                    className="btn-danger btn-sm remove-item"
                    onClick={() => onRemoveItem(item._id, item.selectedBatchId)}
                  >
                    &times;
                  </button>
                </td>
              </tr>
            );
          })}
          {cart.length === 0 && (
            <tr>
              <td colSpan="11" className="text-center text-muted">
                {t("No items in cart")}
              </td>
            </tr>
          )}
          {/* {cart.length > 0 && (
            <>
              <tr className="table-light">
                <td colSpan="6" className="text-end fw-bold">
                  {t("Subtotal")}:
                </td>
                <td colSpan="4" className="text-center fw-bold">
                  {getCurrencySymbol()}
                  {cart.reduce((sum, item) => sum + ((item.salePrice || 0) * (item.quantity || 1)), 0).toFixed(2)}
                </td>
                <td />
              </tr>
              <tr className="table-light">
                <td colSpan="6" className="text-end fw-bold">
                  {t("Total Tax")}:
                </td>
                <td colSpan="4" className="text-center fw-bold text-success">
                  {getCurrencySymbol()}
                  {Object.values(itemTaxes).reduce((sum, tax) => sum + (tax.tax || 0), 0).toFixed(2)}
                </td>
                <td />
              </tr>
            </>
          )} */}
        </tbody>
      </Table>
    </div>
  );
};

export default CartTable;